import React, { Component } from 'react';

import {Link} from 'react-router-dom';

class Footer extends Component {
    
  
    
    render() {
        return  <div className="nav-header">
            <li>
                    <Link >Developed By: Sharif Ahmed</Link>
                </li>
            

            </div>

    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js